'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface QuickAction {
  id: number;
  title: string;
  description: string;
  icon: string;
  color: string;
  action: string;
}

export default function QuickActions() {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const actions: QuickAction[] = [
    {
      id: 1,
      title: "Request Support",
      description: "Create a new support ticket",
      icon: "LifebuoyIcon",
      color: "bg-brand-primary",
      action: "support"
    },
    {
      id: 2,
      title: "Schedule Maintenance",
      description: "Book a maintenance window",
      icon: "CalendarDaysIcon",
      color: "bg-brand-secondary",
      action: "maintenance"
    },
    {
      id: 3,
      title: "Request Service",
      description: "Add new IT services",
      icon: "PlusCircleIcon",
      color: "bg-brand-conversion",
      action: "service"
    },
    {
      id: 4,
      title: "View Reports",
      description: "Access analytics and reports",
      icon: "DocumentChartBarIcon",
      color: "bg-trust-builder",
      action: "reports"
    }
  ];

  const handleActionClick = (action: string) => {
    if (!isHydrated) return;
    console.log(`Action clicked: ${action}`);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-headline font-bold text-primary mb-4">Quick Actions</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => handleActionClick(action.action)}
            className="flex items-start gap-4 p-4 bg-muted/30 hover:bg-muted/50 rounded-lg border border-border hover:border-brand-primary/30 transition-all duration-200 text-left group"
          >
            <div className={`w-12 h-12 ${action.color} rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-200`}>
              <Icon name={action.icon as any} size={24} variant="outline" className="text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-headline font-semibold text-primary mb-1 group-hover:text-brand-primary transition-colors duration-200">
                {action.title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {action.description}
              </p>
            </div>
            <Icon 
              name="ChevronRightIcon" 
              size={20} 
              variant="outline" 
              className="text-muted-foreground group-hover:text-brand-primary group-hover:translate-x-1 transition-all duration-200 flex-shrink-0"
            />
          </button>
        ))}
      </div>
    </div>
  );
}